import { render, staticRenderFns } from "./PerformanceBarChart.vue?vue&type=template&id=1e610130&scoped=true&"
import script from "./PerformanceBarChart.vue?vue&type=script&lang=js&"
export * from "./PerformanceBarChart.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceBarChart.vue?vue&type=style&index=0&id=1e610130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e610130",
  null
  
)

export default component.exports